<template>
  <div
    v-if="shouldShow"
    :style="{ backgroundColor: requirementMet ? '#efffe2' : '#ffe2e2' }"
    class="d-flex align-center"
    style="gap: 16px; padding: 24px; border-radius: 12px"
  >
    <v-icon :color="requirementMet ? '#78BE20' : '#E74B4B'" size="24">
      {{ requirementMet ? 'mdi-check-circle' : 'mdi-alert' }}
    </v-icon>

    <div class="flex-grow-1" style="min-width: 0">
      <div style="font-weight: 700; font-size: 16px; line-height: 24px; letter-spacing: -0.48px; color: #191919">
        {{ title }}
      </div>
      <div style="font-size: 16px; line-height: 24px; letter-spacing: -0.48px; color: #191919; margin-top: 4px">
        <template v-if="isCumulative">
          Your current GPA is {{ formattedCurrentGPA }}.
          <a
            :href="cumulativeGPACalculatorUrl"
            target="_blank"
            rel="noopener"
            style="color: #8c1d40; text-decoration: underline"
            >Calculate your cumulative GPA</a
          >
          to confirm you are meeting the program requirement of a {{ formattedMinGPA }} cumulative GPA.
          <template v-if="!requirementMet">
            Enroll in the recommended courses below to help increase your GPA or
            <a href="#" style="color: #8c1d40; text-decoration: underline" @click.prevent="handleExplorePathways"
              >explore other pathways.</a
            >
          </template>
        </template>
      </div>
    </div>

    <InfoTooltip v-if="isCumulative" variant="dark" :interactive="true">
      <template #activator="{ props: tooltipProps }">
        <v-icon
          v-bind="tooltipProps"
          color="#747474"
          size="24"
          class="align-self-start flex-shrink-0"
          style="cursor: pointer"
        >
          mdi-information-outline
        </v-icon>
      </template>
      Cumulative GPA includes transfer credits from previous institutions and new course work completed with ASU.
      <a
        :href="cumulativeGPACalculatorUrl"
        target="_blank"
        rel="noopener"
        style="color: #ffffff; text-decoration: underline"
      >
        Calculate your CGPA
      </a>
    </InfoTooltip>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import InfoTooltip from '@/components/ui/InfoTooltip.vue';

export default defineComponent({
  name: 'PathwayGPABanner',

  components: {
    InfoTooltip
  },

  props: {
    gpa: {
      type: Object,
      default: null
    },
    minGPA: {
      type: Number,
      default: 0
    },
    isCumulative: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      cumulativeGPACalculatorUrl: 'https://gpacalculator.io/cumulative-gpa-calculator/'
    };
  },

  methods: {
    handleExplorePathways() {
      this.$router.push({ path: '/pathways', query: { scrollTo: 'degrees' } });
    }
  },

  computed: {
    shouldShow() {
      // Only higher-admission-requirement pathways (SF Is_Cumulative__c) surface the GPA banner
      return this.isCumulative && this.minGPA > 0 && this.gpa !== null && this.gpa.gpa !== undefined;
    },
    requirementMet() {
      return this.gpa && this.gpa.gpa >= this.minGPA;
    },
    title() {
      return this.requirementMet ? 'GPA requirement met' : 'GPA requirement not met';
    },
    formattedCurrentGPA() {
      return Number(this.gpa?.gpa ?? 0).toFixed(2);
    },
    formattedMinGPA() {
      return Number(this.minGPA).toFixed(2);
    }
  }
});
</script>
